module.exports = __webpack_public_path__ + "img/img1.980d3233.png";